module.exports = __webpack_public_path__ + "static/media/next_page.97e33711.svg";